import { ReactElement, Fragment } from 'react';
import { Outlet, Link as RouterLink } from 'react-router-dom';
import { Box, Button, Stack } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { ROUTES } from '../../helpers/constans';
import { EUserPermission } from '../../types/@user';

const System = (): ReactElement => {
  const permission = useSelector((state: RootState) => Number(state.auth.permission || 0));
  const isAdmin = permission >= EUserPermission.ADMIN;

  return (
    <Fragment>
      <Box sx={{ p: 2, pb: 0 }}>
        <Stack direction="row" spacing={2} flexWrap="wrap">
          <Button component={RouterLink} to={ROUTES.system} variant="outlined">System events</Button>
          {isAdmin ? (
            <Button component={RouterLink} to={ROUTES.systemEventsRive} variant="outlined">Event rive manager</Button>
          ) : null}
        </Stack>
      </Box>
      <Outlet />
    </Fragment>
  );
};
export default System;
